//                         __
//    ________  ________  / /______
//   / ___/ _ \/ ___/ _ \/ __/ ___/
//  / /  /  __(__  )  __/ /_(__  )
// /_/   \___/____/\___/\__/____/

/* global  */

import { app } from './app';

const resets = () => {
  console.log('{ resets }');

  // Srcset sizes attr
  // updateSizesAttr();

  // Reset app
  app.controller = null;
  app.youtubePlayers = [];

  // Reset on click events
  $(document).off('click');
};

export { resets };



// WEBPACK FOOTER //
// ./scripts/modules/resets.js